import { render, staticRenderFns } from "./TestingRequests.vue?vue&type=template&id=4c8c1e59&"
import script from "./TestingRequests.vue?vue&type=script&lang=js&"
export * from "./TestingRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TestingRequests.vue"
export default component.exports